import { render, staticRenderFns } from "./ResellProduct.vue?vue&type=template&id=a8b92cc4"
import script from "./ResellProduct.vue?vue&type=script&lang=js"
export * from "./ResellProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports